/* eslint-disable */

import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { useHistory } from 'react-router';

import PageUrls from 'Shared/constants/PageUrls.constants';
import { WpPageHeader, WpPageBody, WpPageTitle, WpPageUtilityNavBar } from 'Wpds/components/page-layout';
import { WpTabs, WpTab } from 'Wpds/components/tabs';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';

import SalesforceSyncPanel from '../SalesforceSyncPanel/SalesforceSyncPanel';

import './TopNavigation.scss';
const TopNavigation = () => {
  const history = useHistory();

  const handleBackToAssisstantsPageClick = () => {
    history.push(PageUrls.ASSISTANTS_PAGE);
  };
  return (
    <>
      <WpPageUtilityNavBar width="full">
        <WpButton size="sm" variant="tertiary" onClick={handleBackToAssisstantsPageClick}>
          <WpIcon name="angle-left" />
          Assistants
        </WpButton>
      </WpPageUtilityNavBar>
      <WpPageHeader width="full">
        <WpPageTitle
          title="Sales Assistant"
          subTitle="Configure CRM Data Quality nudges for your team."
          buttonsContainer={<SalesforceSyncPanel />}
        />
        <WpTabs>
          <WpTab to="/assistants/sales" exact>
            Settings
          </WpTab>
          <WpTab to="/assistants/sales/notifications">Notifications</WpTab>
          <WpTab to="/assistants/sales/import_salesforce_users">Users</WpTab>
        </WpTabs>
      </WpPageHeader>
    </>
  );
};

export default TopNavigation;
